import DashBoardContainer from '../../containers/dashBoard/dashBoardContainer';

export default function DashBoardPage() {
  return <DashBoardContainer />;
}
